<template>

	<section class="container" v-if="product">

		<header class="container__header">

			<section class="settings">

				<h1 v-text="product.title"></h1>

				<ws-dropdown>

					<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

					<template slot="content">

						<ul>
							<li><a href="#" @click.prevent="" v-clipboard:copy="product.url"><i class="fas fa-clipboard"></i> Kopier link</a></li>
							<li><router-link :to="{name:'product.edit', params:{product:product.id}}"><i class="fas fa-pencil-alt"></i> Rediger</router-link></li>
							<li><router-link :to="{name:'product.status', params:{product:product.id}}"><i class="fas fa-ban"></i> Inaktive datoer</router-link></li>
							<li><a href="#" @click.prevent="showDeleteModal = true"><i class="fas fa-trash-alt"></i> Slet</a></li>

							<li>
								<a href="#" :class="{'disabled':!product.active}"  @click.prevent="doShowActivationModal" :disabled="!product.active">
									<template v-if="!product.active"><i class="fas fa-eye"></i> Aktiver</template>
									<template v-else><i class="fas fa-eye-slash"></i> Deaktiver</template>
								</a>
							</li>
						</ul>

					</template>

				</ws-dropdown>

			</section>

		</header>

		<section class="container__body container__body--lg">

			<header class="col-12 padding-b-25 border-b">

				<section class="col-6 flex--space">

					<h1>Inaktive datoer</h1>

				</section>

				<section class="col-6">

					<section class="col-6">

						<section class="datepicker pull-right">

							<a href="#" @click.prevent="showDatePickerModal = true"><i class="icon--md fas fa-plus"></i>Tilføj dato</a>

						</section>

					</section>

					<section class="col-6">

						<section class="select-xsm pull-right">

							<ws-select :options="availableYears" v-model="currentYear" :selectByValue="true"></ws-select>

						</section>

					</section>

				</section>

			</header>

			<section class="date-list">

				<transition-group name="fade" mode="out-in">

					<section class="item" v-for="month in inactiveDatesForCurrentYear" :key="month.monthNumber">

						<section class="month">

							<h3>{{month.monthName}}</h3>

						</section>

						<section class="days">

							<ul>

								<li v-for="date in month.dates">

									<a href="#" @click.prevent="deleteDate(date)">{{date.inactive_at | moment('D')}}</a>

								</li>

							</ul>

						</section>

					</section>

				</transition-group>

			</section>

		</section>

		<ws-modal v-model="showDeleteModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-calendar-alt icon--lg margin-b-25"></i>

					<h1>Aktiver dato</h1>

					<h2 v-if="dateToDelete">Er du sikker på du vil gøre den {{dateToDelete.inactive_at | moment('DD/MM/YYYY')}} aktiv?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<section class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="doDeleteDate">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</section>

				</section>

			</section>

		</ws-modal>

		<ws-modal v-model="showDatePickerModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<section class="datepicker-trigger" id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'range'"
								:date-one="dateStartForDatePicker"
								:date-two="dateEndForDatePicker"
								:showActionButtons="false"
								:monthsToShow="1"
								:min-date="today"
								:disabled-dates="inactiveDatesForCalendar"
								@date-one-selected="setStartDate"
								@date-two-selected="setEndDate"
								:end-date="endDate"
						/>
					</section>

				</section>

			</section>

		</ws-modal>

	</section>
</template>

<script>
    import {format} from 'date-fns';
    import da from 'date-fns/locale/da';
    import moment from 'moment';
    export default {
        name: "inactive-dates",
		data(){
            return {
				product:null,
				inactiveDatesFromServer:[],
                showDatePickerModal:false,
                showDeleteModal:false,
                dateStartForDatePicker:'',
                dateEndForDatePicker:'',
                dateStart:'',
                dateEnd:'',
				currentYear:moment().format('YYYY'),
                format,
				monthNames:{
				    '01':'Januar',
					'02':'Februar',
					'03':'Marts',
					'04':'April',
					'05':'Maj',
					'06':'Juni',
					'07':'Juli',
					'08':'August',
					'09':'September',
					'10':'Oktober',
					'11':'November',
					'12':'December',
				},
				dateToDelete:null,
				today:moment().format('YYYY-MM-DD'),
			};
		},
        computed:{
			availableYears(){
			    return [
			        moment().format('YYYY'),
					moment().add(1, 'year').format('YYYY'),
					moment().add(2, 'year').format('YYYY'),
					moment().add(3, 'year').format('YYYY'),
				]
			},
			inactiveDatesForCurrentYear(){
			    if(this.inactiveDatesFromServer.length === 0){
			        return [];
				}

				const dates = this.inactiveDatesFromServer[this.currentYear];

			    if(!dates){
			        return [];
				}

				return Object.keys(dates).map(key =>{
				    const date = dates[key];
				    return {
				        monthNumber: key,
				        monthName: this.monthNames[key],
						dates: date.sort((a,b)=>{
						    return new Date(a.inactive_at) - new Date(b.inactive_at);
						}),
					}
				}).sort((a,b) => {
				    return a.monthNumber - b.monthNumber;
				});
			},
			inactiveDatesForCalendar(){
				const inactiveDates = Object.keys(this.inactiveDatesFromServer).flatMap(year => {
				    return Object.keys(this.inactiveDatesFromServer[year]).flatMap(month => {
                        return this.inactiveDatesFromServer[year][month].map(date => {

                            return moment(date.inactive_at).format('YYYY-MM-DD');
						})

					})
				})

                const today = moment();
                const endDate = moment().add(2, 'y');

                let now = today.clone();
                let dates = [];

                while(now.isSameOrBefore(endDate)){
                    if (now.isoWeekday() == 1){
                        dates.push(now.format('YYYY-MM-DD'));
                    }
                    now.add(1,'days');
                }

                return dates.concat(inactiveDates);
			},
            endDate(){
                return moment().add(2, 'y').format('YYYY-MM-DD');
            }
        },
		methods:{
            getProductAndDates(){
                axios.get(`/api/admin/product/${this.$route.params.product}/status`).then(response => {
                    this.product = response.data.data.product;
                    this.inactiveDatesFromServer = response.data.data.inactive_dates;
                });
			},
            setStartDate(val){
                this.dateStartForDatePicker = val;
            },
            setEndDate(val){
                this.dateStart = this.dateStartForDatePicker;
                this.dateEnd = val;
                this.createInactiveDate();
                this.datePickerReset()
            },
            datePickerReset(){
                this.showDatePickerModal = false;
                this.dateStartForDatePicker = '';
                this.dateEndForDatePicker = '';
            },
			deleteDate(date){
                this.dateToDelete = date;
                this.showDeleteModal = true;
			},
			doDeleteDate(){
                axios.delete(`/api/admin/product/${this.product.id}/deactivate/${this.dateToDelete.id}`).then(response => {
                    this.getProductAndDates();
                    this.dateToDelete = null;
                    this.showDeleteModal = false;
				});
			},
			createInactiveDate(){
                if(this.dateStart === this.dateEnd){
                    axios.post(`/api/admin/product/${this.product.id}/deactivate/date`, {
                        inactive_at:this.dateStart,
                    }).then(response => {
                        this.getProductAndDates();
					});
				}else{
                    axios.post(`/api/admin/product/${this.product.id}/deactivate/date/range`, {
                        start_at:this.dateStart,
                        end_at:this.dateEnd,
                    }).then(response => {
                        this.getProductAndDates();
                    });
				}
			}
		},
		created(){
			this.getProductAndDates();
		}
    }
</script>

<style scoped>

</style>
